/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_No_DevicesInputs */



/**
* | output |
* | --- |
* | "No devices granted — click Request Device" |
*
* @param {Options_Pedal_No_DevicesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_no_devices = /** @type {((inputs?: Options_Pedal_No_DevicesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_No_DevicesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "de") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "it") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "ru") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "es") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "ja") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "hi") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
	return /** @type {LocalizedString} */ ("No devices granted — click Request Device")
});